<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="scheduleEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'Add'}} Automatic Scheduling</h2>
        <mat-dialog-content>
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field>
                      <mat-label>Interval</mat-label>
                        <input matInput [value]="'Interval: ' + Copy.getTimeString()" disabled>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <app-document-selector [(ngModel)]="Copy.Document" name="Document" required
                                           placeholder="Template"></app-document-selector>
                </div>
                <div class="col-sm-6">
                    <mat-form-field>
                      <mat-label>New document type</mat-label>
                        <mat-select [(ngModel)]="Copy.DocumentType" name="doctype"
                                    [compareWith]="compareFn" required>
                            <mat-option *ngFor="let documentType of _Global.Division?.DocumentTypes"
                                        [value]="documentType">{{documentType.Title}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <!--div class="row">
                <mat-radio-group name="type" [(ngModel)]="Type">
                    <div class="col-sm-4">
                        <mat-radio-button [value]="0">Wekelijks</mat-radio-button>
                    </div>
                    <div class="col-sm-4">
                        <mat-radio-button [value]="1">Maandelijks</mat-radio-button>
                    </div>
                    <div class="col-sm-4">
                        <mat-radio-button [value]="2">Jaarlijks</mat-radio-button>
                    </div>
                </mat-radio-group>
            </div-->
            <div class="row">
                <div class="col-sm-5">
                    <!--ng-container *ngIf="Type === 0"-->
                    <mat-form-field>
                      <mat-label>Day of week</mat-label>
                        <mat-select [(ngModel)]="Copy.DayOfWeek" name="weekly"
                                    (ngModelChange)="Copy.DayOfMonth = null" [required]="!Copy.DayOfMonth">
                            <mat-option *ngFor="let x of Days; let i = index" [value]="i">{{x}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!--/ng-container>
                    <ng-container *ngIf="Type === 1">
                        <mat-form-field>
                            <mat-select [(ngModel)]="Copy.DayOfMonth" placeholder="Dag" name="monthly">
                                <mat-option *ngFor="let x of MonthDays; let i = index" [value]="i+1">{{i+1}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>
                    <ng-container *ngIf="Type === 2"-->
                </div>
                <div class="col-sm-2">
                    <mat-form-field>
                      <mat-label>- OF -</mat-label>
                        <input matInput [value]="'- OF -'" disabled style="text-align: center">
                    </mat-form-field>
                </div>
                <div class="col-sm-5">
                    <mat-form-field>
                      <mat-label>Day of month</mat-label>
                        <mat-select [(ngModel)]="Copy.DayOfMonth" name="yearlydat"
                                    (ngModelChange)="Copy.DayOfWeek = null"
                                    [required]="!Copy.DayOfWeek && Copy.DayOfWeek !== 0">
                            <mat-option *ngFor="let x of MonthDays; let i = index" [value]="i+1">{{i+1}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field>
                      <mat-label>Month</mat-label>
                        <mat-select [ngModel]="Copy.MonthOfYear === null ? '100' : Copy.MonthOfYear"
                                    (ngModelChange)="Copy.MonthOfYear = $event === '100' ? null : $event;"
                                    name="yearly">
                            <mat-option value="100">Iedere maand</mat-option>
                            <mat-option *ngFor="let x of Months; let i = index" [value]="i">{{x}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!--/ng-container-->
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <mat-checkbox [(ngModel)]="Copy.IsActive" name="active">
                        Active
                    </mat-checkbox>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <span *ngIf="Copy.Id" class="mat-button mat-raised-button mat-warn" appConfirmDialog
                  (confirm)="remove(Copy, true)">Verwijder</span>
            <div class="fill-remaining-space"></div>
            <button mat-button mat-raised-button [mat-dialog-close]="true">Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
